$("[data-product-gallery]").slick({
    infinite: true,
    autoplay: false,
    autoplaySpeed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "180px",
    prevArrow: '<button type="button" class="slick-arrow slick-prev"><i class="fa fa-angle-left"></i></button>',
    flèche suivante : '<button type="button" class="slick-arrow slick-next"><i class="fa fa-angle-right"></i></button>',
    responsive: [
        {
            breakpoint: 778,
            settings: {
                centerPadding: "50px",
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
            },
        },
    ],
});

$(document).ready(function() {
    var $parent = $('.et-howitwork__tab-buttons');

    var $children = $parent.find('.et-howitwork-link');

    if ($children.length >= 4) {
        $parent.addClass('grid-col-4');
    }
});
$(".et-howitwork__tabs").each(function() {
    var $section = $(this);
    
    $section.find(".et-howitwork__tab:first").addClass("active");
    $section.find(".et-howitwork-link:first").addClass("active");

    $section.find(".et-howitwork-link").on("click", function(e) {
        e.preventDefault();
        
        $section.find(".et-howitwork-link").removeClass("active");
        $section.find(".et-howitwork__tab").removeClass("active");
        
        $(this).addClass("active");
        
        var tagid = $(this).attr('href');
        $section.find(tagid).addClass('active');
    });
});

$(".et-howtouse-link").on("click", function(e){
    e.preventDefault();
    $(".et-howtouse-link").removeClass("active");
    $(".et-howtouse__tab").removeClass("active");
    $(this).addClass("active");
    var tagid = $(this).attr('href');
    $(tagid).addClass('active');
});

$(".et-easystep-link").on("click", function(e){
    e.preventDefault();
    $(".et-easystep-link").removeClass("active");
    $(".et-easystep__tab").removeClass("active");
    $(this).addClass("active");
    var tagid = $(this).attr('href');
    $(tagid).addClass('active');
});

$("[data-icon-slider]").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    cssEase: 'linear',
    arrows: false,
    variableWidth: true,
    loop: true
});

$("[data-prod-google-rev-slider]").slick({
    infinite: true,
    autoplay: false,
    autoplaySpeed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-arrow slick-prev"><i class="fa fa-angle-left"></i></button>',
    flèche suivante : '<button type="button" class="slick-arrow slick-next"><i class="fa fa-angle-right"></i></button>',
    responsive: [
        {
            breakpoint: 778,
            settings: {
                centerPadding: "50px",
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
            },
        },
    ],
});

$(".et-social-image-new_wrap").slick({
    infinite: true,
    autoplay: false,
    autoplaySpeed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-arrow slick-prev"><i class="fa fa-angle-left"></i></button>',
    flèche suivante : '<button type="button" class="slick-arrow slick-next"><i class="fa fa-angle-right"></i></button>',
    responsive: [
        {
            breakpoint: 778,
            settings: {
                centerPadding: "50px",
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
            },
        },
    ],
});


if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
    
    $('[data-tested-mobile-slider]').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
        centerMode: true,
        centerPadding: "70px",
    });

    $('[data-howitwork-mobile-slider]').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
        centerMode: true,
        centerPadding: "50px",
    });

    $('.et-seen-on-wrap').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 2000
    });
  
    $('.et-three-step-wrap').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        prevArrow: '<button class="slick-arrow slick-prev" type="button"> <i class="fa fa-angle-left"></i> </button>',
        flèche suivante : '<button class="slick-arrow slick-next" type="button"><i class="fa fa-angle-right"></i></button>',
    });

  
    // $('.et-header-v1__main-nav, .et-collection-fillter').slick({
    //     slidesToShow: 1,
    //     speed: 300,
    //     variableWidth: true,
    //     arrows: true,
    //     dots: false,
    //     loop: true,
    //     swipe: true,
    //     draggable: true,
    //     swipeToSlide: true,
    //     useCSS: false,
    //     centerMode: true,
    //     infinite: true,
    //     prevArrow: '<button class="main-nav-arrow-left" type="button"> <i class="fa fa-angle-left"></i> </button>',
    // nextArrow : '<button class="main-nav-arrow-right" type="button"><i class="fa fa-angle-right"></i></button>',
    // });

}


$("[data-how-it-work-select]").change(function(){
    var selectOption = $(this).children("option:selected").val();
    $(".et-howitwork__tab").hide();
    $("#"+selectOption).show();
});

$(".et-faq-item").click(function() {
    if ($(this).siblings().hasClass("active")) {
        $(".et-faq-item").removeClass("active");
    }
    $(this).toggleClass("active");
});

$(".et-bombsare__item-des-mobile-toggle").on("click", function(){
    //$(this).toggleClass("active");
    $(this).parent().toggleClass("active");

    //$(this).siblings(".et-bombsare__item-des").toggleClass("active");
    if($(this).parent().hasClass("active")) {
        $(this).children("span").text("View Less");
    } else {
        $(this).children("span").text("View More");
    }

    if($(this).parent().siblings().hasClass("active")) {
        $(this).parent().siblings().removeClass("active")
    }


});


$("[data-search-open]").on("click", function(){
    $('.et-header-search-section').addClass('active');
    $(".et-header-search__overlay").addClass("active");
    $("body").css("overflow", "hidden");
});
$(".et-search-close, .et-header-search__overlay").on("click", function(){
    $('.et-header-search-section').removeClass('active');
    $(".et-header-search__overlay").removeClass("active");
    $("body").css("overflow", "inherit");
});

$("[data-sub-menu-parent]").on("click", function(){
    $(this).parent().children('ul.sub-menu').toggleClass('active');
});

$(".et-mobile-nav-drawer__header-close, .et-mobile-navigation__overlay").on("click", function(e){
    e.preventDefault();
    $(".et-mobile-nav-drawer").css("left", "-100%");
    $(".et-mobile-navigation__overlay").hide();
    $("body").css("overflow", "inherit");
});

$(".et-mobile-bar").on("click", function(){
    $(".et-mobile-nav-drawer").css("left", "0");
    $(".et-mobile-navigation__overlay").show();
    $("body").css("overflow", "hidden");
});

/*===============================================
     Tabs Nav
================================================== */

// Show the first tab and hide the rest
$('.tabs-nav li:first-child').addClass('active');
$('.tab-prod-section').hide();
$('.tab-prod-section:first').show();

// Click function
$('.tabs-nav li a').on('click', function(){
    $('.tabs-nav li').removeClass('active');
    $(this).parent().addClass('active');
    $('.tab-prod-section').hide();

    var activeTab = $(this).parent().find('a').attr('href');
    $(activeTab).fadeIn();
    return false;
});




$(".et-tab-prod-section-inner, .et-product-carousel-wrap-inner").slick({
    infinite: true,
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerPadding: "180px",
    prevArrow: '<button type="button" class="slick-arrow slick-prev"><i class="fa fa-angle-left"></i></button>',
    flèche suivante : '<button type="button" class="slick-arrow slick-next"><i class="fa fa-angle-right"></i></button>',
    responsive: [
        {
            breakpoint: 778,
            settings: {
                centerPadding: "50px",
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
            },
        },
    ],
});


window.addEventListener("load", function() {
	// store tabs variable
	var myTabs = document.querySelectorAll("ul.nav-tabs > li");
  function myTabClicks(tabClickEvent) {
		for (var i = 0; i < myTabs.length; i++) {
			myTabs[i].classList.remove("active");
		}
		var clickedTab = tabClickEvent.currentTarget;
		clickedTab.classList.add("active");
		tabClickEvent.preventDefault();
		var myContentPanes = document.querySelectorAll(".tab-pane");
		for (i = 0; i < myContentPanes.length; i++) {
			myContentPanes[i].classList.remove("active");
		}
		var anchorReference = tabClickEvent.target;
		var activePaneId = anchorReference.getAttribute("href");
		var activePane = document.querySelector(activePaneId);
		activePane.classList.add("active");
	}
	for (i = 0; i < myTabs.length; i++) {
		myTabs[i].addEventListener("click", myTabClicks)
	}
});




// $(".et-drinkbomb-new .db-button").on("click",function(f) {
//   f.preventDefault();
//   $(".et-popup").fadeIn(500);
// });

// $(".et-popup-close").on("click", function() {
//   $(".et-popup").fadeOut(500);
// });



$(".et-drinkbomb-new .db-button").on("click", function() {
    $("body").addClass("overflow-hidden");
    $(".et-popup-overlay").addClass("active");
    $(".et-popup").addClass("active");
});
  
  $(".et-popup-close").on("click", function(){
    $(".et-popup").removeClass("active");
    $("body").removeClass("overflow-hidden");
    $(".et-popup-overlay").removeClass("active");
  });
  
  
jQuery(document).mouseup(function(e) {
    var container = jQuery('.et-popup.active');
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        $(".et-popup").removeClass("active");
        $("body").removeClass("overflow-hidden");
        $(".et-popup-overlay").removeClass("active");
    }
});




$(".et-tab-popup-toggle").on("click",function(f) {
  f.preventDefault();
  $(".et-sticky-header").addClass("z-index-none");
  $("body").addClass("overflow-none");
  $(".et-tab-popup-wrap").addClass("active");
  $(".et-tab-popup-overlay").addClass("active");
});

$(".et-tab-popup-close").on("click", function() {
  $(".et-tab-popup-wrap").removeClass("active");
  $(".et-tab-popup-overlay").removeClass("active");
  $(".et-sticky-header").removeClass("z-index-none");
  $("body").removeClass("overflow-none");
});

$(".et-hero-carousel__wrap").slick({
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    prevArrow: '<button type="button" class="slick-arrow slick-prev"><i class="fa fa-angle-left"></i></button>',
    flèche suivante : '<button type="button" class="slick-arrow slick-next"><i class="fa fa-angle-right"></i></button>'
}) ;

